var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0C6.045 0 0 6.044 0 13.5A13.5 13.5 0 0013.5 27C20.956 27 27 20.956 27 13.5S20.955 0 13.5 0zm1.26 4.874c1.317 0 1.704.763 1.704 1.637 0 1.09-.872 2.098-2.361 2.098-1.246 0-1.84-.626-1.803-1.662 0-.874.73-2.073 2.46-2.073zm-3.371 16.71c-.9 0-1.557-.546-.928-2.944l1.03-4.253c.179-.681.208-.954 0-.954-.268 0-1.437.47-2.126.934l-.448-.736c2.186-1.826 4.7-2.898 5.776-2.898.9 0 1.05 1.063.6 2.7l-1.18 4.472c-.21.79-.12 1.063.09 1.063.27 0 1.152-.326 2.021-1.011l.51.683c-2.128 2.126-4.447 2.945-5.345 2.945z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.09c8ba2e85cae831ea00fe5572f408d2.svg";
export { ForwardRef as ReactComponent };